import React, { useState } from 'react';
import { Dashboard } from './pages/Dashboard';
import { HQDashboard } from './pages/HQDashboard';
import { Header } from './components/Header';
export function App() {
  const [currentView, setCurrentView] = useState<'hq' | 'site'>('hq');
  const [selectedSiteId, setSelectedSiteId] = useState<string | undefined>(undefined);
  const handleViewChange = (view: 'hq' | 'site', siteId?: string) => {
    setCurrentView(view);
    setSelectedSiteId(siteId);
  };
  const getSiteName = (id?: string) => {
    if (!id) return 'Main Gate';
    const sites: Record<string, string> = {
      s1: 'Lucknow Hub',
      s2: 'Delhi NCR',
      s3: 'Mumbai Port'
    };
    return sites[id] || 'Main Gate';
  };
  return <div className="min-h-screen bg-[#0f1115]" data-id="element-0">
      <Header currentView={currentView} siteName={getSiteName(selectedSiteId)} onViewChange={handleViewChange} data-id="element-1" />
      {currentView === 'hq' ? <HQDashboard onViewSite={id => handleViewChange('site', id)} data-id="element-2" /> : <Dashboard data-id="element-3" />}
    </div>;
}